import { Trash2 } from 'lucide-react';
import type { NodePath } from '@/components/tree-dnd/tree-dnd-types';
import { useTreeDndStore } from '@/components/tree-dnd/tree-dnd-store';
import { useI18nContext } from '@/i18n/i18n-react';
import { Button } from '@/components/ui/button';

interface TreeDndDeleteButtonProps {
  path: NodePath;
}

export function TreeDndDeleteButton({ path }: TreeDndDeleteButtonProps) {
  const { LL } = useI18nContext();
  const removeNode = useTreeDndStore((state) => state.removeNode);

  if (path.length === 0) return null;

  return (
    <Button
      type="button"
      variant="ghost"
      size="icon"
      className="size-7 shrink-0 text-muted-foreground hover:text-destructive"
      aria-label={LL.audiences.filters.delete()}
      onClick={() => removeNode(path)}
      onPointerDown={(event) => event.stopPropagation()}
    >
      <Trash2 className="size-4" />
    </Button>
  );
}
